import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qa-session-settings flex col gap-20" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "qa-ss-head" }, "Settings", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Coach Mode ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Open Card ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_QaButton = _resolveComponent("QaButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Toggle, {
      id: "coach-mode-toggle",
      modelValue: _ctx.coachMode,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.coachMode) = $event)),
      title: "coach mode"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.coachMode)
      ? (_openBlock(), _createBlock(_component_QaButton, {
          key: 0,
          onClick: _withModifiers(_ctx.openCardDisplay, ["prevent"]),
          title: "Opens a separate window showing just the reference for screen sharing"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}